import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProductCard } from '../components/ProductCard';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
const products = [{
  title: 'Entendiendo a Nicolás Maduro: Más Allá de la Figura Política',
  image: 'https://cdn.magicpatterns.com/uploads/uvAyCZZaC6PjjN5yUmq5Q2/NICOLAS_MADURO_PORTADA_AUDIBLE.png',
  benefits: ['Línea temporal clara y estructurada', 'Audiolibro para aprender en movimiento', 'Presentación visual con gráficos clave'],
  ctaText: 'Descarga el pack completo de Maduro hoy'
}, {
  title: 'Hugo Chávez: Historia, Legado y Controversia en un Solo Recurso',
  image: 'https://cdn.magicpatterns.com/uploads/aP2neq44kxspUcj6xdhazx/HUGO_CHAVEZ_PORTADA_AUDIBLE.png',
  benefits: ['Análisis completo de su legado', 'Audiolibro para escuchar en cualquier lugar', 'Presentación visual para repasar los puntos esenciales'],
  ctaText: 'Profundiza en la historia de Chávez: Consigue el pack ahora'
}, {
  title: 'María Corina Machado: Trayectoria e Impacto en la Política Contemporánea',
  image: 'https://cdn.magicpatterns.com/uploads/kwNQF2KZeU9CmxhdqZ6eFU/MARIA_CORINA_PORTADA_AUDIBLE.png',
  benefits: ['Recorrido neutral de su carrera', 'Audiolibro para aprender de forma práctica', 'Presentación visual con hitos clave'],
  ctaText: 'Accede al pack completo de María Corina hoy'
}];
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#0a0a0a]" data-id="element-111">
      <HeroSection data-id="element-112" />

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-113" />

      {/* Product Sections */}
      {products.map((product, index) => <div key={product.title} data-id="element-114">
          <ProductCard title={product.title} image={product.image} benefits={product.benefits} ctaText={product.ctaText} reversed={index % 2 === 1} index={index} data-id="element-115" />
          {index < products.length - 1 && <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent" data-id="element-116" />}
        </div>)}

      {/* Final Offer */}
      <FinalOffer data-id="element-117" />

      {/* Footer */}
      <Footer data-id="element-118" />
    </main>;
}